import Skeleton from '@mui/material/Skeleton';
import React from 'react';

const TwitterSkeletonItem: React.FC = () => {
  const separationLineStyle = { marginTop: '5px', marginBottom: '5px' };
  const avatarStyle = { marginBottom: '5px' };

  return (
    <div style={{ width: 500, marginLeft: '25%' }}>
      <Skeleton animation="wave" height={2} style={separationLineStyle} />
      <div style={{ display: 'grid', gridTemplateColumns: '50px 200px' }}>
        <div>
          <Skeleton variant="circular" width={40} height={40} style={avatarStyle} />
        </div>
        <div>
          <Skeleton animation="wave" height={10} width="80%" style={{ marginBottom: 6 }} />
          <Skeleton animation="wave" height={10} width="40%" style={{ marginBottom: 6 }} />
        </div>
      </div>
      <Skeleton variant="rectangular" height={118} />
    </div>
  );
};

export default TwitterSkeletonItem;
